// extracted by mini-css-extract-plugin
module.exports = {"right":"DoubleArrowIcon_right__q6iO5","left":"DoubleArrowIcon_left__1cbYK","top":"DoubleArrowIcon_top__R9Ov1","bottom":"DoubleArrowIcon_bottom__kD2sx"};